import { LIST as LIST_MUTATIONS } from "../mutations";
import { LIST as LIST_ACTIONS } from "../actions";
// import Vue from "vue";
const state = {
	loading: false, //是否正在发起获取权限的请求
	is_request: false, //是否已经向后端发起过请求
	corp_list: [],
	depart_list: [],
	group_list: [],
};


const mutations = {
	//修改加载状态
	[LIST_MUTATIONS.SET_LOADING](state, loading) {
		state.loading = loading;
	},

	//修改请求状态
	[LIST_MUTATIONS.SET_IS_REQUEST](state, is_request) {
		state.is_request = is_request;
	},
	//获取公司
	[LIST_MUTATIONS.SET_CORP_LIST](state, list) {
		state.corp_list = list;
	},
	//获取部门
	[LIST_MUTATIONS.SET_DEPART_LIST](state, list) {
		state.depart_list = list;
	},
	//获取小组
	[LIST_MUTATIONS.SET_GROUP_LIST](state, list) {
		state.group_list = list;
	},
};

const actions = {
	[LIST_ACTIONS.REQUEST_LIST]({ commit }) {
		commit(LIST_MUTATIONS.SET_LOADING, true);
		return new Promise(() => {
		//return new Promise((resolve, reject) => {
			// Vue.$_invoke("adminUser_getSearchData")
			// 	.then((res) => {
			// 		//
			// 		console.log('进来获取');
			// 		console.log(res);
			// 		const { corp_list, depart_list, group_list } = res;
			// 		commit(LIST_MUTATIONS.SET_CORP_LIST, corp_list);
			// 		commit(LIST_MUTATIONS.SET_DEPART_LIST, depart_list);
			// 		commit(LIST_MUTATIONS.SET_GROUP_LIST, group_list);
			// 		commit(LIST_MUTATIONS.SET_LOADING, false);
			// 		commit(LIST_MUTATIONS.SET_IS_REQUEST, true);
			// 		resolve(res);
			// 	})
			// 	.catch((e) => {
			// 		reject(e);
			// 	})
			// 	.finally(() => {
			// 		commit(LIST_MUTATIONS.SET_LOADING, false);
			// 	});
		});
	},
};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
};
